import Url from 'url';

import React, { Component } from 'react';
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

import { toggleMode } from '../../../../actions/style';

import PrivacyBanner from './privacy-banner';

const styles = (theme) => ({
  footer: {
    //bottom: 0,
    display: 'block',
    //left: 0,
    //position: 'fixed',
  },
  footerContainer: {

  },
  footerDivider: {
    height: '2px'
  },
  footerItem: {
    paddingRight: '25px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '10px'
    }
  },
  footerLink: {
    textDecoration: 'none',
  },
  footerModeToggleIcon: {
    cursor: 'pointer',
    width: '15px'
  },
  footerModeToggleContainer: {
    paddingTop: '8px'
  },
  footerStopHand: {
    height: '16px',
    marginRight: '4px',
    width: '16px'
  },
  footerText: {
    fontSize: '13px',
    fontWeight: 'normal',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px'
    },
  },
  footerButton: {
    top: '-10px',
    position: 'relative'
  },
  iconCcpa: {
    float: 'left',
    margin: '3px 5px 0px 0px',
    width: '28px',
  },
  otSettings: {
    position: 'relative',
    background: 'none!important',
    border: 'none!important',
    fontSize: '13px!important',
    color: 'rgba(0, 0, 0, 0.87)!important',
    cursor: 'pointer',
    fontFamily: 'Karla, sans-serif!important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px! important'
    },
    textTransform: 'uppercase',
    paddingRight: '0px!important',
    paddingLeft: '0px!important'
  }
});

class Footer extends Component {
  constructor(props) {
    super(props);

    const dismissedPrivacyBanner = localStorage.getItem('gnid.dismissedPrivacyBanner');

    this.state = {
      dismissedPrivacyBanner: dismissedPrivacyBanner === 'true'
    };

    this.theme = 1;

    this.createLink = this.createLink.bind(this);
    this.getCCPAFooter = this.getCCPAFooter.bind(this);
    this.getGDPRFooter = this.getGDPRFooter.bind(this);
    this.onDismissPrivacyBanner = this.onDismissPrivacyBanner.bind(this);
    this.toggleDayNight = this.toggleDayNight.bind(this);
  }

  onDismissPrivacyBanner() {
    this.setState({ dismissedPrivacyBanner: true });
    localStorage.setItem('gnid.dismissedPrivacyBanner', 'true');
  }

  createLink(url, text, image) {
    const parsed = decodeURIComponent(url);
    const parts = Url.parse(parsed);

    return (
      <Grid item className={this.props.classes.footerItem}>
        <p className={this.props.classes.footerText}>
          {image}<Link color="inherit" href={url} rel="noopener noreferrer" target="_blank" aria-label={`Visit ${parts.hostname} (opens in a new tab)`}>{text}</Link>
        </p>
      </Grid>
    );
  }

  getCCPAFooter() {
    const publicDir = !window.globals || !window.globals.gidPublic ? '' : window.globals.gidPublic;
    const ccpaImage = <img className={this.props.classes.iconCcpa} src={`${publicDir}/img/icon-ccpa.svg`} alt='CCPA' />;

    return (
      <Grid container spacing={0} justifyContent="center" className={this.props.classes.footerContainer}>
        {this.createLink(this.props.adChoicesUrl, 'AD CHOICES', null)}
        {this.createLink(this.props.privacyPolicyUrl, 'PRIVACY POLICY', null)}
        {this.createLink(this.props.doNotSellUrl, 'YOUR PRIVACY CHOICES', ccpaImage)}
        {this.createLink(this.props.caNotice, 'CA NOTICE', null)}
        {this.createLink(this.props.termsAndConditionsUrl, 'TERMS OF SERVICE', null)}
      </Grid>
    );
  }

  getGDPRFooter() {
    const cookieNoticeUrl = window.globals?.gid?.links?.cookiePolicy || this.props.cookiePolicyUrl;

    return (
      <Grid container spacing={0} justifyContent="center" className={this.props.classes.footerContainer}>
        {this.createLink(this.props.adChoicesUrl, 'AD CHOICES', null)}
        {this.createLink(this.props.privacyPolicyUrl, 'PRIVACY POLICY', null)}
        {this.createLink(cookieNoticeUrl, 'COOKIE NOTICE', null)}
        {this.createLink(this.props.termsAndConditionsUrl, 'TERMS OF SERVICE', null)}
      </Grid>
    );
  }

  toggleDayNight() {
    const mode = this.props.mode === 'light' ? 'dark' : 'light';
    this.props.toggleMode(mode);
  }

  render() {
    const showPrivacyBanner = window.globals?.gid?.privacy?.visible;
    if (showPrivacyBanner && !this.state.dismissedPrivacyBanner) {
      return (
        <footer className={this.props.classes.footer}>
          <PrivacyBanner onDismissPrivacyBanner={this.onDismissPrivacyBanner} />
        </footer>
      );
    }

    const year = new Date().getFullYear();

    let footerLinks = null;

    if (window.globals && typeof window.globals.gidShowCCPA !== 'undefined') {
      if (window.globals.gidShowCCPA) {
        footerLinks = this.getCCPAFooter();
      } else {
        footerLinks = this.getGDPRFooter();
      }
    }

    return (
      <footer className={this.props.classes.footer}>
        <Divider className={this.props.classes.footerDivider} color="primary" />
        {footerLinks}
        <Grid container spacing={0} justifyContent="center" className={this.props.classes.footerContainer}>
          <Grid item className={this.props.classes.footerItem}>
            <p className={this.props.classes.footerText}>
              COPYRIGHT &copy; {year} GOLF CHANNEL, ALL RIGHTS RESERVED.
            </p>
          </Grid>
        </Grid>
      </footer>
    );
  }
}

const mapStateToProps = state => {
  return {
    mode: state.mode
  }
}

const ConnectedFooter = connect(mapStateToProps, { toggleMode })(Footer);

export default withStyles(styles)(ConnectedFooter);
